import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
// Global vuex
import AppModule from './app';

// Example Apps
// import BoardModule from '../apps/board/store'
// import EmailModule from '../apps/email/store'
// import TodoModule from '../apps/todo/store'
import DataPlatformModule from '../apps/data-platform/store';
import AudiencesModule from '../apps/audiences/store';
import AttributesModule from '../apps/attributes/store';
import CustomerInsightsModule from '../apps/customer-insigths/store';
import AnalyticServicesModule from '../apps/analytic-services/store';
import localforage from 'localforage';
Vue.use(Vuex);
var vuexAttributesLocal = new VuexPersistence({
  storage: localforage,
  reducer: function reducer(state) {
    return {
      attribute: state.attribute,
      app: state.app,
      dataplatform: state.dataplatform
    };
  }
});

/**
 * Main Vuex Store
 */
var store = new Vuex.Store({
  modules: {
    app: AppModule,
    'data-platform': DataPlatformModule,
    'audience': AudiencesModule,
    'attribute': AttributesModule,
    'customer-insights': CustomerInsightsModule,
    'analytic-services': AnalyticServicesModule
    // 'board-app': BoardModule,
    // 'email-app': EmailModule,
    // 'todo-app': TodoModule
  },
  plugins: [vuexAttributesLocal.plugin]
});
export default store;